import { isMockMode, postId, simulateDelay } from "../api";

export const updateUsersAdmin = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return postId("admin/updateusers", data, {
		successMessage: "User successfully updated",
	});
};
